export type Locale = 'en' | 'zh' | 'ja' | 'ko';

export const translations = {
  en: {
    // Game controls
    newGame: 'New Game',
    cancel: 'Cancel',
    startGame: 'Start Game',
    pause: 'Pause',
    selfPlay: 'Self-Play',
    replay: 'Replay',
    botMode: 'Bot Mode:',
    // Game info
    handicap: 'Handicap:',
    komi: 'Komi:',
    move: 'Move:',
    // Status
    botThinking: 'Bot thinking...',
    // Button tooltips
    aiPlay: 'AI Play (Enter)',
    bestNextMoves: 'Best Next Moves (B)',
    alternativeMoves: 'Alternative Moves for Current Position (A)',
    alt: 'ALT',
    scoreBtn: 'Score (S)',
    firstMove: 'First Move (Home)',
    back10: 'Back 10 (Ctrl+←)',
    prevMove: 'Previous Move (← or Backspace)',
    nextMove: 'Next Move (→)',
    next10: 'Next 10 (Ctrl+→)',
    lastMove: 'Last Move (End)',
    undo: 'Undo (U)',
    returnToMainLine: 'Return to Main Line',
    passBtn: 'Pass (P)',
    load: 'Load',
    save: 'Save',
    loadSgf: 'Load SGF',
    saveSgf: 'Save SGF',
    startSelfPlay: 'Start self-play (AI vs AI)',
    pauseSelfPlay: 'Pause self-play',
    replayFromCurrent: 'Replay moves from current position',
    // Error dialog
    error: 'Error',
    close: 'Close',
    // Error messages
    noMovesToSave: 'No moves to save',
    failedToCreateGame: 'Failed to create game',
    failedToLoadSgf: 'Failed to load SGF file',
    failedToGetMove: 'Failed to get move from KataGo',
    failedToGetScore: 'Failed to get score from KataGo',
    // New game dialog
    newGameTitle: 'New Game',
    evenGame: 'Even game',
    stones: 'stones',
    // Tabs
    badMoves: 'Bad Moves',
    comment: 'Comment',
    // Bad moves panel
    sort: 'Sort:',
    byBadness: 'By Badness',
    byMoveNum: 'By Move #',
    threshold: 'Threshold:',
    noBadMoves: 'No bad moves found!',
    lowerThreshold: 'Lower the threshold to see more moves',
    blunder: 'Blunder',
    mistake: 'Mistake',
    inaccuracy: 'Inaccuracy',
    // Comment box
    noComment: 'No comment for this move.',
    // System status
    gatewayUnreachable: 'Gateway unreachable',
    systemHealthy: 'System healthy',
    noWorkersConnected: 'No workers connected',
    systemStatus: 'System Status',
    updatedAt: 'updated',
    gateway: 'GATEWAY',
    queue: 'Queue:',
    pending: 'Pending:',
    statusLabel: 'Status:',
    workersLabel: 'WORKERS',
    activeLabel: 'active',
    idleLabel: 'idle',
    modelLabel: 'model:',
    configLabel: 'config:',
    workerLabel: 'worker',
    // Mode toggle
    mode: 'Mode:',
    playMode: 'Play',
    studyMode: 'Study',
    switchToPlay: 'Switch to Play mode',
    switchToStudy: 'Switch to Study mode',
    resign: 'Resign',
    passBtn2: 'Pass',
    confirmResign: 'Are you sure you want to resign?',
    // Language switcher
    language: 'Language',
  },

  zh: {
    newGame: '新游戏',
    cancel: '取消',
    startGame: '开始',
    pause: '暂停',
    selfPlay: '自弈',
    replay: '回放',
    botMode: '人机模式：',
    handicap: '让子：',
    komi: '贴目：',
    move: '手数：',
    botThinking: 'AI 思考中…',
    aiPlay: 'AI 落子 (Enter)',
    bestNextMoves: '最佳下一手 (B)',
    alternativeMoves: '当前局面候选手 (A)',
    alt: '候选',
    scoreBtn: '估分 (S)',
    firstMove: '第一手 (Home)',
    back10: '后退10手 (Ctrl+←)',
    prevMove: '上一手 (← 或 Backspace)',
    nextMove: '下一手 (→)',
    next10: '前进10手 (Ctrl+→)',
    lastMove: '最后一手 (End)',
    undo: '悔棋 (U)',
    returnToMainLine: '返回主线',
    passBtn: '虚手 (P)',
    load: '加载',
    save: '保存',
    loadSgf: '加载 SGF',
    saveSgf: '保存 SGF',
    startSelfPlay: '开始自弈（AI 对 AI）',
    pauseSelfPlay: '暂停自弈',
    replayFromCurrent: '从当前位置回放',
    error: '错误',
    close: '关闭',
    noMovesToSave: '没有可保存的棋谱',
    failedToCreateGame: '创建游戏失败',
    failedToLoadSgf: '加载 SGF 文件失败',
    failedToGetMove: '获取 AI 落子失败',
    failedToGetScore: '获取估分失败',
    newGameTitle: '新游戏',
    evenGame: '分先',
    stones: '子',
    badMoves: '坏棋',
    comment: '注释',
    sort: '排序：',
    byBadness: '按坏棋程度',
    byMoveNum: '按手数',
    threshold: '阈值：',
    noBadMoves: '没有找到坏棋！',
    lowerThreshold: '降低阈值以查看更多手',
    blunder: '大恶手',
    mistake: '失误',
    inaccuracy: '疑问手',
    noComment: '此手无注释。',
    gatewayUnreachable: '网关不可达',
    systemHealthy: '系统正常',
    noWorkersConnected: '无工作节点连接',
    systemStatus: '系统状态',
    updatedAt: '更新于',
    gateway: '网关',
    queue: '队列：',
    pending: '待处理：',
    statusLabel: '状态：',
    workersLabel: '工作节点',
    activeLabel: '活跃',
    idleLabel: '空闲',
    modelLabel: '模型：',
    configLabel: '配置：',
    workerLabel: '节点',
    mode: '模式：',
    playMode: '对局',
    studyMode: '复盘',
    switchToPlay: '切换到对局模式',
    switchToStudy: '切换到复盘模式',
    resign: '认输',
    passBtn2: '虚手',
    confirmResign: '确定要认输吗？',
    language: '语言',
  },

  ja: {
    newGame: '新規対局',
    cancel: 'キャンセル',
    startGame: '開始',
    pause: '一時停止',
    selfPlay: '自動対局',
    replay: '再生',
    botMode: 'AI対局：',
    handicap: '置き石：',
    komi: 'コミ：',
    move: '手数：',
    botThinking: 'AI 思考中…',
    aiPlay: 'AI 着手 (Enter)',
    bestNextMoves: '次の一手候補 (B)',
    alternativeMoves: '現局面の候補手 (A)',
    alt: '候補',
    scoreBtn: '形勢判断 (S)',
    firstMove: '最初の手 (Home)',
    back10: '10手戻る (Ctrl+←)',
    prevMove: '前の手 (← または Backspace)',
    nextMove: '次の手 (→)',
    next10: '10手進む (Ctrl+→)',
    lastMove: '最後の手 (End)',
    undo: '待った (U)',
    returnToMainLine: '本譜に戻る',
    passBtn: 'パス (P)',
    load: '読込',
    save: '保存',
    loadSgf: 'SGF 読込',
    saveSgf: 'SGF 保存',
    startSelfPlay: '自動対局を開始（AI 対 AI）',
    pauseSelfPlay: '自動対局を一時停止',
    replayFromCurrent: '現局面から再生',
    error: 'エラー',
    close: '閉じる',
    noMovesToSave: '保存する手がありません',
    failedToCreateGame: '対局の作成に失敗しました',
    failedToLoadSgf: 'SGF ファイルの読み込みに失敗しました',
    failedToGetMove: 'KataGo からの着手取得に失敗しました',
    failedToGetScore: 'KataGo からの形勢取得に失敗しました',
    newGameTitle: '新規対局',
    evenGame: '互先',
    stones: '子',
    badMoves: '悪手',
    comment: 'コメント',
    sort: '並び替え：',
    byBadness: '悪さ順',
    byMoveNum: '手数順',
    threshold: 'しきい値：',
    noBadMoves: '悪手は見つかりませんでした！',
    lowerThreshold: 'しきい値を下げると更多くの手が表示されます',
    blunder: '大悪手',
    mistake: '失着',
    inaccuracy: '疑問手',
    noComment: 'この手のコメントはありません。',
    gatewayUnreachable: 'ゲートウェイに到達できません',
    systemHealthy: 'システム正常',
    noWorkersConnected: 'ワーカーが接続されていません',
    systemStatus: 'システム状態',
    updatedAt: '更新',
    gateway: 'ゲートウェイ',
    queue: 'キュー：',
    pending: '保留中：',
    statusLabel: '状態：',
    workersLabel: 'ワーカー',
    activeLabel: '稼働中',
    idleLabel: 'アイドル',
    modelLabel: 'モデル：',
    configLabel: '設定：',
    workerLabel: 'ワーカー',
    mode: 'モード：',
    playMode: '対局',
    studyMode: '検討',
    switchToPlay: '対局モードに切替',
    switchToStudy: '検討モードに切替',
    resign: '投了',
    passBtn2: 'パス',
    confirmResign: '投了しますか？',
    language: '言語',
  },

  ko: {
    newGame: '새 대국',
    cancel: '취소',
    startGame: '시작',
    pause: '일시정지',
    selfPlay: '자동 대국',
    replay: '복기',
    botMode: 'AI 대국:',
    handicap: '접바둑:',
    komi: '덤:',
    move: '수:',
    botThinking: 'AI 생각 중…',
    aiPlay: 'AI 착수 (Enter)',
    bestNextMoves: '최선의 다음 수 (B)',
    alternativeMoves: '현재 위치의 후보수 (A)',
    alt: '후보',
    scoreBtn: '형세 판단 (S)',
    firstMove: '첫 수 (Home)',
    back10: '10수 뒤로 (Ctrl+←)',
    prevMove: '이전 수 (← 또는 Backspace)',
    nextMove: '다음 수 (→)',
    next10: '10수 앞으로 (Ctrl+→)',
    lastMove: '마지막 수 (End)',
    undo: '무르기 (U)',
    returnToMainLine: '본보로 돌아가기',
    passBtn: '패스 (P)',
    load: '불러오기',
    save: '저장',
    loadSgf: 'SGF 불러오기',
    saveSgf: 'SGF 저장',
    startSelfPlay: '자동 대국 시작（AI 대 AI）',
    pauseSelfPlay: '자동 대국 일시정지',
    replayFromCurrent: '현재 위치에서 복기',
    error: '오류',
    close: '닫기',
    noMovesToSave: '저장할 수가 없습니다',
    failedToCreateGame: '대국 생성에 실패했습니다',
    failedToLoadSgf: 'SGF 파일 로드에 실패했습니다',
    failedToGetMove: 'KataGo에서 착수를 가져오는데 실패했습니다',
    failedToGetScore: 'KataGo에서 형세 판단을 가져오는데 실패했습니다',
    newGameTitle: '새 대국',
    evenGame: '호선',
    stones: '점',
    badMoves: '악수',
    comment: '코멘트',
    sort: '정렬:',
    byBadness: '나쁨 순',
    byMoveNum: '수 순',
    threshold: '임계값:',
    noBadMoves: '악수를 찾을 수 없습니다!',
    lowerThreshold: '임계값을 낮추면 더 많은 수를 볼 수 있습니다',
    blunder: '대악수',
    mistake: '실수',
    inaccuracy: '부정확한 수',
    noComment: '이 수에 대한 코멘트가 없습니다.',
    gatewayUnreachable: '게이트웨이에 연결할 수 없습니다',
    systemHealthy: '시스템 정상',
    noWorkersConnected: '연결된 워커가 없습니다',
    systemStatus: '시스템 상태',
    updatedAt: '업데이트됨',
    gateway: '게이트웨이',
    queue: '대기열:',
    pending: '대기 중:',
    statusLabel: '상태:',
    workersLabel: '워커',
    activeLabel: '활성',
    idleLabel: '유휴',
    modelLabel: '모델:',
    configLabel: '설정:',
    workerLabel: '워커',
    mode: '모드:',
    playMode: '대국',
    studyMode: '복기',
    switchToPlay: '대국 모드로 전환',
    switchToStudy: '복기 모드로 전환',
    resign: '기권',
    passBtn2: '패스',
    confirmResign: '기권하시겠습니까?',
    language: '언어',
  },
} as const;

export type TranslationKey = keyof typeof translations['en'];
